declare namespace $ {

	export class $mol_icon_language_css3 extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=css3.view.tree.d.ts.map